<template>
    <div>
        <SearchTable />
        <ProgressBar />
    </div>
</template>

<script>
import SearchTable from "@/components/SearchTable";
import ProgressBar from "@/components/ProgressBar";

export default {
    name: "CurriculumSearch",

    components: {
        SearchTable,
        ProgressBar
    },

    data: () => ({})
};
</script>
